import { render, staticRenderFns } from "./ViewTransactionPopup.vue?vue&type=template&id=15c851b9"
import script from "./ViewTransactionPopup.vue?vue&type=script&lang=js"
export * from "./ViewTransactionPopup.vue?vue&type=script&lang=js"
import style0 from "./ViewTransactionPopup.vue?vue&type=style&index=0&id=15c851b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports